import DatePickerWidget from './DatePickerWidget';

export default DatePickerWidget;
